import { render, staticRenderFns } from "./uploadFileBtn.vue?vue&type=template&id=7361aa76&scoped=true"
import script from "./uploadFileBtn.vue?vue&type=script&lang=js"
export * from "./uploadFileBtn.vue?vue&type=script&lang=js"
import style0 from "./uploadFileBtn.vue?vue&type=style&index=0&id=7361aa76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7361aa76",
  null
  
)

export default component.exports